/* eslint-disable react-hooks/exhaustive-deps */
import { LOCAL_STORAGE_KEYS } from "common/constants/localStorageKeys";
import FormFooter from "components/FormFooter/FormFooter";
import RegisterCompanyForm from "components/Register/RegisterCompanyForm";
import RegisterPersonForm from "components/Register/RegisterPersonForm";
import { PageProps } from "models/page";
import { CreateBusinessCustomerRequest, RegisterFormCompany, RegisterFormPerson, CreatePrivateCustomerRequest } from "models/register";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { InitContextProps, useAuthContext } from "services/context/authentication.context";
import RegisterService from "services/register.service";

export default function Register(props: PageProps) {

    const history = useHistory();
    const { state, dispatch }: InitContextProps = useAuthContext();

    const [loading, setLoading] = useState<boolean>(false);
    const [companyForm, setCompanyForm] = useState<RegisterFormCompany>({
        contactEmail: '',
        contactPhone: '',
        wantCreditAndCard: false
    });

    const [error, setError] = useState<string | undefined>();
    
    const [personForm, setPersonForm] = useState<RegisterFormPerson>({
        contactEmail: '',
        contactPhone: '',
        wantsNewsLetter: false,
        termsAndConditions: false
    });

    useEffect(() => {
        props.onLoadValidatePage();
    }, []);

    useEffect(() => {
        setCompanyForm({
            ...companyForm,
            contactEmail: state.user?.email || ''
        })
    }, [state.user]);

    if (!state.registerData) {
        history.replace('/');
        return null;
    }
    const onRegister = (): void => {
        if (state.registerData?.isCompany) {
            onRegisterCompany();
        } else {
            onRegisterPerson();
        }

    }

    const onRegisterCompany = (): void => {
        setError(undefined);
        const request: CreateBusinessCustomerRequest = {
            companyId: state.registerData!.companyId as number,
            wantsCreditAndCard: companyForm.wantCreditAndCard,
            contactEmail: companyForm.contactEmail,
            contactPhone: companyForm.contactPhone,
            estimatedMonthlyLiters: companyForm.estimatedMonthlyLiters,
            wantedCredit: companyForm.wantedCredit,
            additionalInfo: companyForm.additionalInfo
        };
        handleRegisterRequest(RegisterService.createBusinessCustomer(request), false);
    }

    const onRegisterPerson = (): void => {
        setError(undefined);
        const request: CreatePrivateCustomerRequest = {
            name: state.user.name ,
            personalIdentificationCode: state.user.personalIdentificationCode,
            contactEmail: personForm.contactEmail,
            contactPhone: personForm.contactPhone,
            wantsNewsLetter: personForm.wantsNewsLetter,
        };
        handleRegisterRequest(RegisterService.createPrivateCustomer(request), true);
    }

    const handleRegisterRequest = (request: Promise<{ customerId: number }>, isPerson: boolean): void => {
        setLoading(true);
        request
        .then(res => {
            localStorage.setItem(LOCAL_STORAGE_KEYS.CUSTOMER_ID, res.customerId + '');
            dispatch({
                type: "setCustomerId",
                value: res.customerId
            });
            history.push('/');
        })
        .catch(err => setError(getErrorMessage(isPerson, err.message)))
        .finally(() => setLoading(false));
    }

    const nextLabel = companyForm.wantCreditAndCard ? 'Küsi pakkumist' : 'Registreeri';
    let nextButtonDisabled = false;
    if (!state.registerData.isCompany && !personForm.termsAndConditions) {
        nextButtonDisabled = true;
    }

    return (
        <>
            {state.registerData.isCompany ?
                <RegisterCompanyForm
                    name={state.registerData.name}
                    contactName={state.user?.name}
                    form={companyForm}
                    setForm={setCompanyForm}
                    error={error}
                    newCustomer={!state.registerData.customerId}
                /> :
                <RegisterPersonForm
                    name={state.user.name}
                    personalIdentificationCode={state.user.personalIdentificationCode}
                    form={personForm}
                    setForm={setPersonForm}
                    error={error}
                />}
            <FormFooter
                next={() => onRegister()}
                showPrevious={false}
                showNext={true}
                nextButtonDisabled={nextButtonDisabled}
                loading={loading}
                nextLabel={nextLabel}
            />
        </>
    );
}

const getErrorMessage = (isPerson: boolean, message: string): string => {
    if (isPerson)
        return message;
    if (message === 'Customer with generated searchcode already exists!' || message === 'Customer with given regno already exists!')
        return 'Ettevõte on juba Terminali klient!';
    return message;
}